import { FormProvider, useForm } from 'react-hook-form';

import { FC } from 'react';
import { Form } from 'features/common/components/Form';
import { FormValues } from '../../types';
import { Modal } from 'features/common/components/Modal';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

interface AddGateModalProps {
	isOpen: boolean;
	onClose: () => void;
	onSave: (data: FormValues) => void;
}

const ModalContent = styled.div`
	padding: 24px;
	width: 500px;
	max-width: 100%;
`;

const Title = styled.h2`
	margin: 0 0 24px;
	font-size: 20px;
	font-weight: 600;
`;

const ButtonsContainer = styled.div`
	display: flex;
	justify-content: flex-end;
	gap: 16px;
	margin-top: 24px;
`;

const Button = styled.button<{ primary?: boolean }>`
	background: ${({ primary, theme }) => (primary ? theme.colors.whitePearl : 'transparent')};
	color: ${({ primary, theme }) => (primary ? theme.colors.black : theme.colors.whitePearl)};
	border: 1px solid ${({ theme }) => theme.colors.whitePearl};
	padding: 8px 16px;
	border-radius: 4px;
	cursor: pointer;
	font-size: 14px;

	&:hover {
		opacity: 0.8;
	}
`;

export const AddGateModal: FC<AddGateModalProps> = ({ isOpen, onClose, onSave }) => {
	const { t } = useTranslation();
	const methods = useForm<FormValues>({
		defaultValues: {
			newGateName: '',
		},
	});

	const handleSubmit = (data: FormValues) => {
		if (data.newGateName.trim()) {
			onSave(data);
			methods.reset();
		}
	};

	return isOpen ? (
		<Modal onClose={onClose}>
			<ModalContent>
				<Title>{t('Add New Gate')}</Title>

				<FormProvider {...methods}>
					<form onSubmit={methods.handleSubmit(handleSubmit)}>
						<Form.Input id="newGateName" name="newGateName" label={t('Gate Name')} placeholder={t('Enter gate name')} />

						<ButtonsContainer>
							<Button onClick={onClose}>{t('Cancel')}</Button>
							<Button primary type="submit">
								{t('Add Gate')}
							</Button>
						</ButtonsContainer>
					</form>
				</FormProvider>
			</ModalContent>
		</Modal>
	) : null;
};
